module.exports = __webpack_public_path__ + "img/super-hero-2.2f94e6cc.png";